import { Group, Button, ActionIcon, Tooltip } from "@mantine/core";
import { X, Plus } from "lucide-react";

export interface ChartCreateActionsButtonProps {
    handleCancel: () => void;
    handleSave: () => void;
    isSaving: boolean;
}

export function ChartCreateActionsButton({
    handleCancel,
    handleSave,
    isSaving,
}: ChartCreateActionsButtonProps) {
    return (
        <Group justify="flex-end" gap="sm">
            <Tooltip label="Cancel">
                <ActionIcon
                    variant="outline"
                    color="gray"
                    onClick={handleCancel}
                    disabled={isSaving}
                    hiddenFrom="sm"
                    size="lg"
                >
                    <X size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                variant="outline"
                color="gray"
                onClick={handleCancel}
                disabled={isSaving}
                visibleFrom="sm"
                leftSection={<X size={16} />}
            >
                Cancel
            </Button>

            <Tooltip label="Create Chart">
                <ActionIcon
                    color="black"
                    c="white"
                    onClick={handleSave}
                    disabled={isSaving}
                    loading={isSaving}
                    hiddenFrom="sm"
                    size="lg"
                >
                    <Plus size={18} />
                </ActionIcon>
            </Tooltip>
            <Button
                color="black"
                c="white"
                onClick={handleSave}
                disabled={isSaving}
                loading={isSaving}
                visibleFrom="sm"
                leftSection={<Plus size={16} />}
            >
                Create Chart
            </Button>
        </Group>
    );
}
